export const concernedIndividualStatusArray = [
	'NotPerformed',
	'PartiallyPerformed',
	'Performed',
] as const;
export type ConcernedIndividualStatus =
	(typeof concernedIndividualStatusArray)[number];
